import { GET_ALLTMS_FAILED, GET_ALLTMS_LOADING, GET_ALLTMS_REMOVE, GET_ALLTMS_SUCCESS } from "../types";

const initialState = {
  loading: false,
  error: null,
  Countries: null,
};

export const getAllTmsReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_ALLTMS_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_ALLTMS_SUCCESS:
      return {
        ...state,
        loading: false,
        Countries: action.payload,
        error: null,
      };
    case GET_ALLTMS_FAILED:
      return {
        ...state,
        loading: false,
        Countries: null,
        error: action.error,
      };
    case GET_ALLTMS_REMOVE:
      return initialState;
    default:
      return state;
  }
};
